import { images } from "../../assets/images";
import { toFilterId } from "../../utils/toFilterId";
import { gradeOptionLabels } from "./filterOptionLabels";

function mapMasterDataOptions(items = []) {
  return items.map((item) => ({
    id: item.id,
    label: item.name,
    description: item.description ?? null,
  }));
}

function buildGradeOptions() {
  return gradeOptionLabels.map((label) => ({
    id: toFilterId(label),
    label,
  }));
}

export function buildFilterFields({ standards = [], subjects = [] } = {}) {
  return [
    {
      id: "curriculum",
      label: "Curriculum",
      placeholder: "SELECT",
      iconSrc: images.quickSheets.filterCurriculum,
      options: mapMasterDataOptions(standards),
    },
    {
      id: "grade",
      label: "Grade",
      placeholder: "SELECT...",
      iconSrc: images.quickSheets.filterGrade,
      options: buildGradeOptions(),
    },
    {
      id: "subject",
      label: "Subject",
      placeholder: "SELECT...",
      iconSrc: images.quickSheets.filterSubject,
      options: mapMasterDataOptions(subjects),
    },
  ];
}

export function buildAllowedFilterIds(filterFields = []) {
  const allowed = {
    curriculum: new Set(),
    grade: new Set(),
    subject: new Set(),
  };

  for (const field of filterFields) {
    allowed[field.id] = new Set(field.options.map((option) => option.id));
  }

  return allowed;
}

export const settingsAlertMessage =
  "Please select Curriculum, Grade, and Subject from the settings to begin.";
